import { NestedOption } from '~/core/shared/types/utility';
import { PATH_SEPARATOR } from '../constants/separator';

/**
 * Resolves a stored path into the options it names, outermost first, or null when the path
 * names an option that does not exist, stops above a leaf, or continues past one.
 */
export const resolveNestedOptionBranch = (
  options: readonly NestedOption[],
  path: string | null | undefined,
): NestedOption[] | null => {
  if (!path) return null;

  const branch: NestedOption[] = [];
  let level: readonly NestedOption[] | undefined = options;

  for (const segment of path.split(PATH_SEPARATOR)) {
    const matched: NestedOption | undefined = level?.find(
      (option) => option.value === segment,
    );

    if (!matched) return null;

    branch.push(matched);
    level = matched.options;
  }

  return level?.length ? null : branch;
};
